export default __webpack_public_path__ + "static/media/eye.aedf99c2.svg";